import React from 'react';
import $ from 'jquery';
import { Translate } from 'core/translate';

const getNavWrapperHeight = () => {
  const priceSummaryExpandedHeight = $('.price-summary-expanded').height();
  const navHeight = $('#navGroup').height();
  return priceSummaryExpandedHeight
    ? navHeight - priceSummaryExpandedHeight
    : navHeight;
};

const StandardFeatures = props => {
  const { features, analyticsKey } = props;

  const goToAnchor = anchor => {
    const element = document.getElementById(anchor);
    element.scrollIntoView();
    window.scrollBy(0, -1 * getNavWrapperHeight());
  };

  const anchors = Object.keys(features).map(key => {
    return (
      <button
        key={key}
        className="standard-features__anchor stat-text-link"
        data-dtm={analyticsKey ? `${analyticsKey}:${key}` : key}
        onClick={() => goToAnchor(key)}>
        {key}
      </button>
    );
  });

  const sections = Object.keys(features).map(key => {
    return (
      <li key={key} className="standard-features__section" id={key}>
        <div>
          <span>
            <strong>{key}</strong>
          </span>
        </div>
        <FeatureItems items={features[key]} />
        <button
          className="standard-features__back-to-top stat-text-link"
          data-dtm={
            analyticsKey ? `${analyticsKey}:back to top` : 'back to top'
          }
          onClick={() => goToAnchor('features-top')}>
          <Translate value="back.to.top" />
        </button>
      </li>
    );
  });

  return (
    <React.Fragment>
      <div className="standard-features__anchor-list">{anchors}</div>
      <React.Fragment>{sections}</React.Fragment>
    </React.Fragment>
  );
};

StandardFeatures.defaultProps = {
  features: {}
};

const FeatureItems = ({ items }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <ul>
      {items.map((item, key) => {
        return (
          <li key={key} className="standard-features__list-item">
            <span dangerouslySetInnerHTML={{ __html: item.shortCFD }} />
            <span dangerouslySetInnerHTML={{ __html: item.longCFD }} />
            {item.disclaimer ? (
              <span
                className="standard-features__disclaimer"
                dangerouslySetInnerHTML={{ __html: item.disclaimer }}
              />
            ) : null}
          </li>
        );
      })}
    </ul>
  );
};

FeatureItems.defaultProps = {
  items: []
};

export default StandardFeatures;
